// import pages
import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";

import App from "./App";
import { AlertProvider } from "./constants/AlertProvider";
import { ModeProvider } from "./constants/ModeProvider";
import { ThemeProvider } from "./constants/ThemeProvider";

import "../css/output.css";

// Only initialize Sentry with a real DSN. Some envs ship a placeholder
// (e.g. SENTRY_DSN="your-sentry-dsn"), which makes Sentry.init log
// "Invalid Sentry Dsn" on every page load. Mirror the backend's http(s)-scheme
// guard (settings/production.py) so a non-URL placeholder is simply skipped.
if (window.SENTRY_DSN && /^https?:\/\//.test(window.SENTRY_DSN)) {
  Sentry.init({
    dsn: window.SENTRY_DSN,
    release: window.COMMIT_SHA,
  });
}

const root = createRoot(document.getElementById("react-app") as HTMLElement);
root.render(
  <ThemeProvider>
    <AlertProvider>
      <ModeProvider>
        <App />
      </ModeProvider>
    </AlertProvider>
  </ThemeProvider>,
);
